import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container } from 'react-bootstrap'
import { Box, MainHeading, SpanStyled } from '../../../ui/Elements'
import { ArrowBtn, HeroBg, HeroBgAr, Whatsapp, WhatsAppCtnt, WhatsIcon, WhatsIconBtn } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { ButtonWithIcon, ButtonWithIcon2, ContactButton, ContactButtonHref } from '../../../ui/CustomElements'
import SocialLinks from '../../../ui/includes/SocialLinks'
import { Animate } from 'react-simple-animate'
const Banner = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
      const [isVisible, setIsVisible] = useState(false);


    const WhatsApp = () => {
        const phoneNumber = '+966555625502';
        const message = 'Hello, this is Hisas';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
    
    
      useEffect(() => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            // When visible, set to true
            if (entry.isIntersecting) {
              setIsVisible(true);
              observer.disconnect(); // run animation once
            }
          },
          {
            threshold: 0.2, // 20% of section visible triggers the animation
          }
        );
    
        if (sectionRef.current) {
          observer.observe(sectionRef.current);
        }
    
        return () => observer.disconnect();
      }, []);
        const start = { opacity: 0, transform: 'translateY(-40px)' };
        const end = { opacity: 1, transform: 'translateY(0)' };
        const start2 = { opacity: 0, transform: 'translateY(100px)' };
        const end2 = { opacity: 1, transform: 'translateY(0)' };
    return (
        <>
            <BannerWapper className='container-fluid common-space bannerFluid'  id='home' ref={sectionRef}>
                <Container>
                    <Box className='bannerRow row'>
                        <Col md={12} className="pb-0 bannerColMain">
                            <Box className='bannerContent'>
                                <Animate
                                        play={isVisible}
                                        duration={1}
                                        delay={.5}
                                        start={start}
                                        end={end}
                                    >
                                <MainHeading className='main-heading main-heading-banner' color="var(--themeColor)">
                                    {t('GrowwithConfidence')}
                                </MainHeading>
                                </Animate>
                                <Animate
                                        play={isVisible}
                                        duration={1}
                                        delay={.8}
                                        start={start}
                                        end={end}
                                    >
                                <SpanStyled className='bannerText mb-4' color="var(--themeColor)">
                                    {t('Investwithconfidence')}
                                </SpanStyled>
                                </Animate>
                                <Animate
                                        play={isVisible}
                                        duration={1}
                                        delay={1.2}
                                        start={start}
                                        end={end}
                                    >
                                <SpanStyled className='d-flex align-items-center gap-2 flex-sm-wrap bannerTxtWrapper'>
                                    <ContactButtonHref className="cursor-pointer" icon={ArrowBtn} label={t('InvestinHissas')} onClick={WhatsApp} />
                                    {/* <WhatsAppCtnt className='drWhatsBtn cursor-pointeer' onClick={WhatsApp} /> */}
                                    {/* <ButtonWithIcon2 className='drWhatsBtn cursor-pointeer' bg="#25D366" icon={WhatsIconBtn} label={t('whatsapp')} onClick={WhatsApp} /> */}
                                </SpanStyled>
                                </Animate>
                            </Box>
                            

                        </Col>
                        
                    </Box>
                </Container>
            </BannerWapper>
            {/* <SocialLinks /> */}
        </>
    )
}
const BannerWapper = styled.section`
    /* padding-bottom: 2px; */
    background-image: url(${HeroBg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center top;
    display: flex;
    align-items: center;
    /* height: 745px; */
    /* padding-top: 100px; */
    height: 100vh;
    min-height: 550px;
    .bannerColMain{
        display: flex;
        justify-content: end;
        /* overflow: hidden; */
    }
    .bannerContent{
        display: flex;
        width: 490px;
         padding-right: 60px;
        flex-wrap: wrap;
        flex-direction: column;
        /* padding-top: 107px; */
        /* padding-left: 168px; */
        
    }
    .main-heading-banner{
        font-family: var(--bold);
        font-size: 70px;
        margin-bottom: 15px;
    }
    .bannerText{
        font-family: var(--medium);
        font-size: 20px;
        line-height: 1.5;
        
    }
    
    .bannerRow{
        padding: 0px 0px 0 0px;
        align-items: center;
        /* margin-left: 0;
        margin-right: 0; */
    }
    .bannerImgContainer{
        padding-top: 20px;
    } 
    body.rtl &{
        background-image: url(${HeroBgAr});
        background-position: center top;
        .bannerColMain{
            
            
        }
        .bannerContent{
            /* padding-top: 150px; */
            padding-left: 60px;
            padding-right: 0px;
            /* padding-right: 168px; */
            
        }
        .main-heading-banner{
            font-family: var(--arBold);
            font-size: 80px;
            
        }
        .bannerText{
            font-family: var(--arMedium);
            font-size: 18px;
             line-height: 2;
            
        }
            
        
        .bannerRow{
            padding: 0px 0px 0 0px;
            align-items: center;
            
        }
        
        .bannerCol1{
            padding-bottom: 60px !important;
        }
    }
    @media (max-width: 1399px) {
        .bannerRow{
            padding-left: 0;
            padding-right: 0;
        }
        body.rtl &{
            .bannerRow{
                padding: 0px 0px 0 0px;
                
            }
        }
    }
    @media (max-width: 1199px) {
        display: flex;
        align-items: center;
        padding-bottom: 0px;
        /* background-position: center top; */
        /* .main-heading{
            font-size: 55px;
        } */
            .bannerContent{
                width: 430px;
                padding-right: 0;
            }
        body.rtl &{
            .bannerContent{
                padding-left: 0;
            }
        }
    }
    @media (max-width: 1080px) {
        position: relative;
        .bannerTxtWrapper{
            justify-content: center;
        }
        .bannerText{
            /* font-size: 22px; */
            text-align: center;
            color: var(--bg);
        }
        body.rtl &{
            .main-heading-banner{
                font-size: 60px;
            }
        }
    }
    @media (max-width: 1080px) {
        padding-top: 84px;
        /* height: auto; */
        position: relative;
        /* .main-heading{
            font-size: 45px;
            text-align: center;
        } */
        .bannerTxtWrapper{
            justify-content: center;
        }
        .bannerText{
            /* font-size: 22px; */
            text-align: center;
            color: var(--bg);
        }
        
        .bannerCol1{
            padding-bottom: 30px !important;
        }
        .bannerRow{
            position: relative;
            z-index: 5;
        }
        .main-heading-banner{
            font-size: 50px;
            color: var(--bg);
        }
        .bannerContent {
            width: 100%;
            justify-content: center;
            & > *{
                width: 100% ;
                text-align: center;
                justify-content: center;
            }
        }
        &::after{
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);
            z-index: 0;
        }
        body.rtl &{
            /* background-image: url(${HeroBg}); */
            .main-heading-banner{
                font-size: 60px;
                
            }
            .bannerColMain {
                justify-content: start;
            }
            
            
        }
    }
    @media (max-width: 767px) {
        & > .container{
            .bannerColMain{
                /* height: 440px;
                background-size: 1190px 510px;
                background-position: left -40px top -10px; */
                .bannerContent{
                    /* width: 100%; */
                    /* padding-top: 50px;
                    padding-left: 90px; */
                }
            }
        }
        body.rtl &{
            & > .container{
                .bannerColMain{
                    /* background-image: url(${HeroBgAr}); */
                    /* background-size: 1190px 510px;
                    background-position: right -120px top -10px; */
                    .bannerContent{
                        /* padding-top: 70px;
                        padding-right: 9px; */
                        
                    }
                }
            }
             
        }
    }
    @media (max-width: 640px) {
        padding-top: 50px;
        body.rtl &{
            .main-heading-banner{
                font-size: 45px;
            }
            .bannerSubTxt{
                /* font-size: 24px; */
            }
        }
    }
    @media (max-width: 575px) {
        & > .container{
            .bannerColMain{
                /* background-position: left -110px top -10px; */
                .bannerContent{
                    width: 100%;
                    /* padding-top: 50px; */
                    /* padding-left: 10px; */
                    /* padding-right: 10px; */
                }
            }
        }
    }
    @media (max-width: 350px) {
        .main-heading-banner{
            font-size: 40px;
        
        }
        & > .container{
            .bannerColMain{
                .bannerContent{
                    padding-left: 0px;
                    padding-right: 0px;
                }
            }
        }
    }
`
export default Banner
